import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button, Table, Form, Alert, Spinner, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import {
  faArrowLeft,
  faExclamationCircle,
  faCheckCircle,
  faInfoCircle,
  faQuestionCircle,
  faFilePdf,
  faUsers
} from "@fortawesome/free-solid-svg-icons";
import { FaChalkboardTeacher } from "react-icons/fa";

import HeadingBanner from "../components/HeadingBanner";
import SchoolRollNumberInput from "../components/SchoolRollNumberInput";
import AssessmentNotificationManager from "../components/AssessmentNotificationManager";
import LeftPanel from "../components/LeftPanel";
import OrientationPrompt from "../components/OrientationPrompt";
import AladdinExportActivationManager from '../components/AladdinExportActivationManager';
import { saveAs } from "file-saver";

import {
  whoami,
  getClasses,
  getSchools,
  getClassesByAssessmentId,
  getClassesBySchoolId,
  getClassesAssessmentResults,
  postAladdinExportAuditLog,
  sendAladdinResultsEmail,
  getTeachers,
  getTeachersBySchoolId,
  createAssessmentReminder
} from "../services/APIClient";
import { isTeacher } from "../utils/auth";
import { useSearchParams } from "react-router-dom";

import {
  groupClassResultsforExport
} from "../services/GroupAndAverageTasks";
import {
  ALADDIN_IMPORT_PDF_FILENAME,
  ALADDIN_IMPORT_PDF_URL,
  ALADDIN_IMPORT_VIDEO_URL,
  buildAladdinZipFileName,
  createAladdinResultsZip
} from "../services/AladdinExportHelper";

import "../components/AladdinExport.css";

const customStyles = `
  .aladdin-export-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .aladdin-main-content {
    flex: 1;
    overflow-y: auto;
    padding: 0;
  }

  .school-input-wrapper {
    width: 100%;
    padding: 0;
    margin: 0;
  }

  .content-card-wrapper {
    width: 100%;
    padding: 1.5rem;
  }

  .staff-contact-list {
    max-height: 300px;
    overflow-y: auto;
  }
  
  .staff-contact-item {
    transition: all 0.2s ease;
    background-color: #f8f9fa;
  }
  
  .staff-contact-item:hover {
    background-color: #e9ecef;
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  }
  
  .role-icon {
    font-size: 1.5rem;
    min-width: 40px;
    text-align: center;
  }
  
  .staff-name {
    text-align: center;
    width: 100%;
  }

  .trial-class-row {
    background-color: #fff3cd !important;
    border-left: 4px solid #ffc107;
  }
  
  .trial-badge {
    background-color: #ffc107;
    color: #212529;
    font-size: 0.75rem;
    font-weight: bold;
    padding: 2px 6px;
    border-radius: 4px;
    margin-left: 8px;
  }
  
  .trial-class-name {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .student-count-cell {
    text-align: center;
    vertical-align: middle;
  }

  .student-count-display {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }

  .student-count-number {
    font-weight: bold;
    color: #0d6efd;
    font-size: 1rem;
  }

  .class-table-card {
    margin-bottom: 1rem;
  }

  .selection-summary {
    border-top: 1px solid #dee2e6;
    margin-top: 1rem;
  }

  .export-button-container {
    display: flex;
    gap: 0.5rem;
    justify-content: flex-end;
    flex-wrap: wrap;
  }

  .export-button,
  .email-button {
    min-width: 120px;
  }

  .current-selections {
    margin-bottom: 1.5rem;
  }

  .back-button {
    white-space: nowrap;
  }

  .step-indicator {
    color: #495057;
    font-weight: 600;
    margin-bottom: 1rem;
    margin-top: 1rem;
  }

  .step-message {
    padding: 2rem;
    text-align: center;
    color: #495057;
  }

  .loading-container {
    padding: 3rem 1rem;
  }

  .teacher-selection-item {
    background-color: #f8f9fa;
    transition: background-color 0.2s ease;
  }

  .teacher-selection-item:hover {
    background-color: #e9ecef;
  }

  .year-selection-button {
    background-color: #fff;
    border: 2px solid #dee2e6;
    color: #212529;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
  }

  .year-selection-button:hover {
    border-color: #0d6efd;
    box-shadow: 0 4px 8px rgba(13, 110, 253, 0.15);
  }

  .year-selection-button.selected {
    background-color: #0d6efd;
    border-color: #0d6efd;
    color: white;
  }

  .assessment-button {
    background-color: #e7f1ff;
    border: 2px solid #0d6efd;
    color: #0d6efd;
    padding: 1.5rem;
    border-radius: 0.5rem;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    display: block;
    width: 100%;
    margin-bottom: 1rem;
  }

  .assessment-button:hover {
    background-color: #0d6efd;
    color: white;
    box-shadow: 0 4px 12px rgba(13, 110, 253, 0.25);
  }

  .season-assessment-icon {
    height: 60px;
    margin-top: 0.5rem;
  }

  .school-info-header {
    padding: 1rem 0;
    border-bottom: 1px solid #dee2e6;
  }

  .school-info-header h4 {
    margin: 0;
    color: #212529;
  }

  .school-info-header p {
    margin: 0.25rem 0 0 0;
  }
`;

const ROLES = {
  SENCO: 'SENCO',
  PRINCIPAL: 'PRINCIPAL',
  SECRETARY: 'SECRETARY',
  ALPACA_LEAD: 'ALPACA LEAD'
};

function AladdinExport() {
  const [searchParams] = useSearchParams();
  const [schoolid, setSchoolid] = useState("");
  const [schoolName, setSchoolName] = useState("Loading school information...");
  const [rollNumber, setRollNumber] = useState("");
  const [teacherid, setTeacherid] = useState(null);
  const [teachers, setTeachers] = useState(null);
  const [teacherEmail, setTeacherEmail] = useState(null);
  const [teacherName, setTeacherName] = useState(null);
  const [classes, setClasses] = useState([]);
  const [screeners, setScreeners] = useState([]);
  const [selectedScreener, setSelectedScreener] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [assessmentResults, setAssessmentResults] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(null);
  const [emailLoading, setEmailLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedTeachers, setSelectedTeachers] = useState([]);
  const [showScreenerModal, setShowScreenerModal] = useState(false);
  const [showAssessmentNotificationModal, setShowAssessmentNotificationModal] = useState(false);
  const [reminderEmail, setReminderEmail] = useState("");
  const [submittingReminder, setSubmittingReminder] = useState(false);
  const [reminderSubmitted, setReminderSubmitted] = useState(false);
  const [pendingScreenerId, setPendingScreenerId] = useState(null);
  const [userRoles, setUserRoles] = useState([]);
  const [hasExportPermission, setHasExportPermission] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);

  // ✅ Security states
  const [isLoadingSchool, setIsLoadingSchool] = useState(true);
  const [loadError, setLoadError] = useState(null);
  const teacherMode = isTeacher();

  // Check if school has been found
  const isSchoolFound = schoolid && schoolid !== "" && schoolName !== "Loading school information..." && schoolName !== "Please enter school roll number and press 'Find School'";

  const YEAR_RANGES = {
    "25/26": { start: "2025-08-15", end: "2026-08-15" },
    "24/25": { start: "2024-08-15", end: "2025-08-15" },
    "23/24": { start: "2023-08-15", end: "2024-08-15" },
    "22/23": { start: "2022-08-15", end: "2023-08-15" }
  };
  const preselectClassId = searchParams.get("classId");
  const preselectAssessmentId = searchParams.get("assessmentId");

  const PDF_URL = ALADDIN_IMPORT_PDF_URL;
  const VIDEO_URL = ALADDIN_IMPORT_VIDEO_URL;
  const PDF_FILENAME = ALADDIN_IMPORT_PDF_FILENAME;

  const handleScreenerSelect = (screenerId, screenerName) => {
    setSelectedScreener(screenerId);
  };

  const handleShowAssessmentNotificationModal = () => {
    setShowAssessmentNotificationModal(true);
  };

  const handleReminderSubmit = async () => {
    setSubmittingReminder(true);

    try {
      if (!pendingScreenerId) {
        throw new Error("No assessment selected");
      }

      if (!schoolid) {
        throw new Error("School ID is not available");
      }

      const assessmentName = screeners.find((s) => s.id === pendingScreenerId)?.name || "Assessment";

      const reminderData = {
        assessmentid: pendingScreenerId,
        assessmentName: assessmentName,
        academicYear: selectedYear,
        email: reminderEmail || teacherEmail,
        name: teacherName,
        schoolid: schoolid
      };

      console.log("Sending reminder request:", reminderData);
      await createAssessmentReminder(reminderData);

      setReminderSubmitted(true);

      setTimeout(() => {
        setShowScreenerModal(false);
        setReminderEmail("");
        setReminderSubmitted(false);
        setPendingScreenerId(null);
      }, 3000);
    } catch (error) {
      console.error("Error submitting reminder request:", error);
    } finally {
      setSubmittingReminder(false);
    }
  };

  const handleCloseScreenerModal = () => {
    setShowScreenerModal(false);
    setPendingScreenerId(null);
    setReminderEmail("");
  };

  const handleCloseAssessmentNotificationModal = () => {
    setShowAssessmentNotificationModal(false);
  };

  const handleSendToMultipleTeachers = async () => {
    if (!selectedTeachers || selectedTeachers.length === 0) {
      alert("Please select at least one teacher to email results.");
      return;
    }

    setEmailLoading(true);
    setShowModal(false);

    try {
      console.log(`Fetching results for classes:`, selectedClasses);
      let response = await getClassesAssessmentResults(selectedClasses, selectedScreener);

      if (!response || Object.keys(response).length === 0) {
        alert("No results found.");
        setEmailLoading(false);
        return;
      }

      response = groupClassResultsforExport(response);

      const assessmentName = screeners.find((s) => s.id === selectedScreener)?.name || "Assessment";
      const classNames = selectedClasses.map(classId => response[classId]?.name || `Class_${classId}`);

      const emailPayload = {
        assessmentName,
        schoolName,
        rollNumber,
        selectedYear,
        selectedClasses: selectedClasses.map((classId) => ({
          classId,
          className: response[classId]?.name || `Class_${classId}`,
          students: response[classId]?.students || {},
        })),
      };

      console.log("📨 Preparing to send emails with payload:", emailPayload);

      await postAladdinExportAuditLog(
        teacherid,
        schoolid,
        assessmentName,
        selectedScreener,
        selectedClasses,
        classNames,
        "Email",
      );

      console.log("📝 Export tracked successfully in audit logs!");

      const results = [];
      let successCount = 0;
      let failCount = 0;

      for (const teacher of selectedTeachers) {
        try {
          console.log(`Sending email to ${teacher.name} (${teacher.email})...`);
          await sendAladdinResultsEmail(teacher.email, teacher.name, emailPayload);
          results.push({ email: teacher.email, success: true });
          successCount++;
        } catch (error) {
          console.error(`Failed to send email to ${teacher.email}:`, error);
          results.push({ email: teacher.email, success: false, error: error.message });
          failCount++;
        }
      }

      if (successCount === selectedTeachers.length) {
        alert(`✅ Email sent successfully to ${successCount} teacher${successCount !== 1 ? 's' : ''}!`);
      } else if (successCount > 0) {
        alert(`📧 Partial success: Email sent to ${successCount} of ${selectedTeachers.length} teachers. ${failCount} failed.`);
      } else {
        alert(`❌ Failed to send emails to any teachers. Please try again later.`);
      }

      console.log("Email sending results:", results);
    } catch (error) {
      console.error("❌ Error in email process:", error);
      alert("Failed to process or send emails. Please try again later.");
    } finally {
      setEmailLoading(false);
      setSelectedTeachers([]);
    }
  };

  useEffect(() => {
    const fetchUserAndSchoolInfo = async () => {
      try {
        const response = await whoami();
        const stakeholder = response.data.stakeholder;
        setTeacherid(stakeholder.id);
        setTeacherEmail(response.data.email);
        setTeacherName(stakeholder.name);

        const roles = stakeholder.additionalRoles || [];
        setUserRoles(roles);

        const hasPermission = checkUserExportPermission(roles);
        setHasExportPermission(hasPermission);

        console.log("User info:", response);

        // ✅ TEACHER MODE: Auto-load their school
        if (teacherMode) {
          const teacherSchoolId = stakeholder.schoolid || stakeholder.schoolId;
          
          if (!teacherSchoolId) {
            console.error("❌ Teacher has no school ID!");
            setSchoolName("Error: No school assigned");
            setLoadError("No school assigned to your account");
            setIsLoadingSchool(false);
            return;
          }

          console.log("🏫 Teacher mode: Auto-loading school ID:", teacherSchoolId);
          setSchoolid(teacherSchoolId);

          // Fetch school details
          try {
            const schoolsResponse = await getSchools();
            const schools = schoolsResponse.data || schoolsResponse;
            const teacherSchool = Array.isArray(schools) 
              ? schools.find(s => s.id === teacherSchoolId)
              : null;
            
            if (teacherSchool) {
              setSchoolName(teacherSchool.name);
              setRollNumber(teacherSchool.rollnumber || "");
              console.log("✅ Loaded teacher's school:", teacherSchool.name);
            } else {
              setSchoolName("School not found");
              setLoadError("School not found in database");
            }
          } catch (error) {
            console.error("❌ Error fetching school details:", error);
            setSchoolName("Error loading school");
            setLoadError(`Error loading school: ${error.message}`);
          }

          setIsLoadingSchool(false);
        } else {
          // ✅ ALPACA-STAFF MODE: Show search interface
          setSchoolName("Please enter school roll number and press 'Find School'");
          setIsLoadingSchool(false);
        }
      } catch (error) {
        console.error("❌ Error fetching user info:", error);
        setSchoolName("Error loading user information");
        setLoadError(`Error loading user: ${error.message}`);
        setIsLoadingSchool(false);
      }
    };

    fetchUserAndSchoolInfo();
  }, [teacherMode]);

  const checkUserExportPermission = (roles) => {
    const safeRoles = Array.isArray(roles) ? roles : [];

    if (safeRoles.length === 0) return false;

    return safeRoles.some(role => {
      const roleUpper = role.toUpperCase();
      return roleUpper === ROLES.SENCO ||
        roleUpper.includes(ROLES.PRINCIPAL) ||
        roleUpper === ROLES.SECRETARY ||
        roleUpper === ROLES.ALPACA_LEAD;
    });
  };

  useEffect(() => {
    async function fetchSchoolData() {
      if (!isSchoolFound) return;

      try {
        setLoading(true);

        const teachersResponse = await getTeachersBySchoolId(schoolid);
        setTeachers(teachersResponse);

        const classesResponse = await getClasses();
        classesResponse.sort((a, b) => new Date(b.date_created) - new Date(a.date_created));
        setClasses(classesResponse);

        if (!teacherMode) {
          const schoolsResponse = await getSchools();
          const matchingSchool = schoolsResponse.data.find((school) => school.id === schoolid);

          if (matchingSchool) {
            setRollNumber(matchingSchool.rollnumber);
            setSchoolName(matchingSchool.name);

            const screenersAvailable = await fetchScreenersForSchool(schoolid);
            setScreeners(screenersAvailable);
          }
        } else {
          // For teachers, screeners are loaded after school is auto-loaded
          const screenersAvailable = await fetchScreenersForSchool(schoolid);
          setScreeners(screenersAvailable);
        }
      } catch (error) {
        console.error("Error fetching school data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchSchoolData();
  }, [schoolid, isSchoolFound, teacherMode]);

  const fetchScreenersForSchool = async (schoolId) => {
    return [
      { id: '68ce3a92-73e0-4158-9c08-31bff6246d23', name: "Jnr Baseline Assessment" },
      { id: '6a43ae18-2251-4876-8f15-23e2c897fdab', name: "Jnr Midpoint Assessment" },
      { id: 'd613e45e-b3b0-4d0f-bcdc-cc17f38bd285', name: "Jnr End of Year Assessment" },
      { id: '927b2379-998c-4424-af56-1f82e0144765', name: "Snr Baseline Screener" },
      { id: '9b962947-4f59-4e19-a725-40601b66e8ff', name: "Snr Midpoint Screener" },
      { id: '08e97976-f32f-4ad6-a2df-7a2be0789d70', name: "Snr End of Year Assessment" },
    ];
  };

  const getIconFileName = (assessmentName) => {
    let name = assessmentName.toLowerCase();
    if (name.includes("baseline") || name.includes("autumn")) return "autumn";
    if (name.includes("midpoint") || name.includes("spring")) return "spring";
    if (name.includes("end of year") || name.includes("summer")) return "summer";
    return "default";
  };

  const getScreenerAvailabilityMessage = (screenerName) => {
    const name = screenerName.toLowerCase();
    if ((name.includes("end of year") || name.includes("summer")) && selectedYear === "24/25") {
      return "Results available from Mid June";
    }
    return null;
  };

  const handleClassSelect = (classId) => {
    setSelectedClasses((prevSelected) =>
      prevSelected.includes(classId)
        ? prevSelected.filter((id) => id !== classId)
        : [...prevSelected, classId]
    );
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedClasses([]);
    } else {
      setSelectedClasses(classes.map((cls) => cls.classId || cls.id));
    }
    setSelectAll(!selectAll);
  };

  const generateZipFileName = () => {
    return buildAladdinZipFileName({
      rollNumber,
      schoolName,
      assessmentName: screeners.find((s) => s.id === selectedScreener)?.name || "Assessment",
      academicYearKey: selectedYear
    });
  };

  const prepareResultsZip = async () => {
    if (selectedClasses.length === 0) {
      alert("Please select at least one class.");
      return null;
    }

    try {
      console.log(`Fetching results for classes:`, selectedClasses);
      let response = await getClassesAssessmentResults(selectedClasses, selectedScreener);

      console.log("API Response:", response);
      if (!response || Object.keys(response).length === 0) {
        alert("No results found.");
        return null;
      }

      const { zip } = await createAladdinResultsZip({
        rawResults: response,
        selectedClassIds: selectedClasses,
        assessmentName: screeners.find((s) => s.id === selectedScreener)?.name || "Assessment",
        rollNumber
      });

      return zip;
    } catch (error) {
      console.error("Error preparing ZIP:", error);
      alert("Error preparing ZIP file.");
      return null;
    }
  };

  const exportResults = async () => {
    if (selectedClasses.length === 0) {
      alert("Please select at least one class to export.");
      return;
    }

    setExportLoading(true);

    try {
      const zip = await prepareResultsZip();
      if (!zip) {
        setExportLoading(false);
        return;
      }

      const assessmentName = screeners.find((s) => s.id === selectedScreener)?.name || "Assessment";
      const classNames = selectedClasses.map(classId => classes.find(cls => (cls.classId || cls.id) === classId)?.name || `Class_${classId}`);

      await postAladdinExportAuditLog(
        teacherid,
        schoolid,
        assessmentName,
        selectedScreener,
        selectedClasses,
        classNames,
        "Export",
      );

      console.log("📝 Export tracked successfully in audit logs!");

      zip.generateAsync({ type: "blob" }).then(blob => {
        saveAs(blob, generateZipFileName());
        setExportLoading(false);
      });

    } catch (error) {
      console.error("❌ Error exporting results:", error);
      alert("Failed to export results.");
      setExportLoading(false);
    }
  };

  const formatDate = (isoDate) => {
    if (!isoDate) return "";

    const date = new Date(isoDate);
    if (isNaN(date.getTime())) return "Invalid Date";

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = String(date.getUTCFullYear()).slice(-2);

    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    async function fetchClassesForScreener() {
      if (!selectedScreener || !schoolid || !selectedYear) return;

      try {
        setLoading(true);

        const yearRange = YEAR_RANGES[selectedYear];
        if (!yearRange) {
          console.error("Invalid year selected:", selectedYear);
          return;
        }

        const timeframe = {
          start: yearRange.start,
          end: yearRange.end
        };

        const filteredClasses = await getClassesByAssessmentId(selectedScreener, schoolid, timeframe);
        const allSchoolClasses = await getClassesBySchoolId(schoolid);

        const studentCountMap = new Map();
        allSchoolClasses.forEach(cls => {
          studentCountMap.set(cls.id, cls.studentNumber || 0);
        });

        const classesWithStudentCounts = filteredClasses.map(cls => ({
          ...cls,
          studentNumber: studentCountMap.get(cls.classId || cls.id) || 0
        }));

        console.log("Filtered classes with student counts:", classesWithStudentCounts);
        setClasses(classesWithStudentCounts);
        if (preselectClassId && classesWithStudentCounts.some((cls) => (cls.classId || cls.id) === preselectClassId)) {
          setSelectedClasses([preselectClassId]);
          setSelectAll(false);
        } else {
          setSelectedClasses([]);
          setSelectAll(false);
        }
      } catch (error) {
        console.error("Error fetching classes for selected screener:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchClassesForScreener();
  }, [selectedScreener, schoolid, selectedYear, preselectClassId]);

  useEffect(() => {
    if (!preselectAssessmentId || selectedScreener || screeners.length < 1) {
      return;
    }

    const matchingScreener = screeners.find((screener) => screener.id === preselectAssessmentId);
    if (matchingScreener) {
      setSelectedScreener(preselectAssessmentId);
      setSelectedYear((currentYear) => currentYear || Object.keys(YEAR_RANGES)[0]);
    }
  }, [preselectAssessmentId, screeners, selectedScreener]);

  const getFilteredTeachers = () => {
    if (!teachers || !Array.isArray(teachers)) {
      console.log("Teachers is not an array:", teachers);
      return [];
    }

    console.log("Getting filtered teachers from:", teachers);

    try {
      return teachers.filter(teacher => {
        if (!teacher || typeof teacher !== 'object') {
          console.log("Invalid teacher item:", teacher);
          return false;
        }

        const roles = Array.isArray(teacher.additionalRoles) ? teacher.additionalRoles : [];

        if (roles.length === 0) {
          return false;
        }

        return checkUserExportPermission(roles);
      });
    } catch (error) {
      console.error("Error in getFilteredTeachers:", error);
      return [];
    }
  };

  const getAuthorizedTeachers = () => {
    if (!teachers || !Array.isArray(teachers)) {
      console.log("Teachers is not an array:", teachers);
      return [];
    }

    try {
      return teachers.filter(teacher => {
        if (!teacher || typeof teacher !== 'object') {
          console.log("Invalid teacher item:", teacher);
          return false;
        }

        const roles = Array.isArray(teacher.additionalRoles) ? teacher.additionalRoles : [];

        if (roles.length === 0) {
          return false;
        }

        return checkUserExportPermission(roles);
      });
    } catch (error) {
      console.error("Error in getAuthorizedTeachers:", error);
      return [];
    }
  };

  const getTotalSelectedStudents = () => {
    return selectedClasses.reduce((total, classId) => {
      const classItem = classes.find(cls => (cls.classId || cls.id) === classId);
      return total + (classItem?.studentNumber || 0);
    }, 0);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedTeachers([]);
  };

  return (
    <Container fluid className="aladdin-export-wrapper vh-100">
      <style>{customStyles}</style>

      <HeadingBanner name="Aladdin Export" isLoggedIn={true} cloud={true} teacherid={teacherid} />
      
      <div className="aladdin-main-content">
        <Row className="g-0 h-100">
          <Col xs={12} sm={2} className="p-0">
            <LeftPanel />
          </Col>

          <Col xs={12} sm={10} className="p-0 d-flex flex-column">
            {/* School Input Section */}
            <div className="school-input-wrapper">
              {teacherMode ? (
                // ✅ TEACHER VIEW: Show their school (locked)
                <div className="p-4 bg-white border-bottom">
                  {loadError && (
                    <Alert variant="danger" className="mb-3">
                      <strong>⚠️ Error Loading School</strong>
                      <p className="mb-0">{loadError}</p>
                    </Alert>
                  )}
                  <div className="mb-2">
                    <h5 className="mb-1">Your School</h5>
                    <Alert variant="secondary" className="mb-2 d-inline-flex align-items-center">
                      <FaChalkboardTeacher className="me-2" />
                      <span className="small">You are exporting results for your school</span>
                    </Alert>
                  </div>
                  {isLoadingSchool ? (
                    <div className="text-center py-3">
                      <Spinner animation="border" variant="primary" size="sm" className="me-2" />
                      <span>Loading your school information...</span>
                    </div>
                  ) : (
                    <>
                      <h4 className="text-primary mb-1">{schoolName}</h4>
                      {rollNumber && (
                        <p className="text-muted mb-0">Roll Number: {rollNumber}</p>
                      )}
                    </>
                  )}
                </div>
              ) : (
                // ✅ ALPACA-STAFF VIEW: Show search interface
                <SchoolRollNumberInput
                  onSchoolIdRetrieved={setSchoolid}
                  schoolNameRetrieved={(name, rollNum) => {
                    setSchoolName(name);
                    if (rollNum) setRollNumber(rollNum);
                  }}
                />
              )}
            </div>

            {/* Main Content Section */}
            <div className="content-card-wrapper flex-grow-1 overflow-auto">
              {!teacherMode && 
              <AladdinExportActivationManager />
              }

              <Card className="h-100">
                {loading ? (
                  <div className="loading-container d-flex flex-column align-items-center justify-content-center">
                    <Spinner animation="border" role="status" className="mb-2" />
                    <span>Loading...</span>
                  </div>
                ) : !isSchoolFound ? (
                  <div className="step-message">
                    {teacherMode ? (
                      isLoadingSchool ? (
                        <div className="d-flex flex-column align-items-center">
                          <Spinner animation="border" role="status" className="mb-2" />
                          <span>Loading your school information...</span>
                        </div>
                      ) : (
                        <h4>{loadError || "Unable to load school information. Please contact support."}</h4>
                      )
                    ) : (
                      <h4>Enter School Roll Number to begin</h4>
                    )}
                  </div>
                ) : !selectedYear ? (
                  <Card.Body>
                    <div className="school-info-header mb-3">
                      <h4 className="mb-1">{schoolName}</h4>
                      <p className="text-muted">Roll Number: {rollNumber}</p>
                    </div>
                    <h5 className="step-indicator">Step 1: Select Academic Year</h5>
                    <Row className="justify-content-center mb-3">
                      {Object.keys(YEAR_RANGES).map((year) => (
                        <Col md={4} key={year} className="mb-3">
                          <button
                            className={`year-selection-button w-100 py-3 shadow-sm rounded ${selectedYear === year ? "selected" : ""}`}
                            onClick={() => setSelectedYear(year)}
                          >
                            <h3>{year}</h3>
                            <small className="text-muted d-block mt-2">
                              {new Date(YEAR_RANGES[year].start).toLocaleDateString('en-IE', { month: 'short', year: 'numeric' })} -
                              {new Date(YEAR_RANGES[year].end).toLocaleDateString('en-IE', { month: 'short', year: 'numeric' })}
                            </small>
                          </button>
                        </Col>
                      ))}
                    </Row>
                  </Card.Body>
                ) : !selectedScreener ? (
                  <Card.Body>
                    <div className="current-selections p-3 mb-3 bg-light rounded">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <h5 className="mb-1">{schoolName}</h5>
                          <p className="mb-0 text-muted">Academic Year: {selectedYear}</p>
                        </div>
                        <Button variant="secondary" size="sm" className="back-button" onClick={() => setSelectedYear(null)}>
                          <FontAwesomeIcon icon={faArrowLeft} /> Change Year
                        </Button>
                      </div>
                    </div>

                    <h5 className="step-indicator">Step 2: Select a Screener Point</h5>
                    <Row>
                      {screeners.length > 0 ? (
                        screeners.map((screener) => (
                          <Col md={4} key={screener.id} className="mb-3">
                            <button
                              className="assessment-button"
                              onClick={() => handleScreenerSelect(screener.id, screener.name)}
                            >
                              {screener.name} <br />
                              <img
                                src={`/assets/imgs/${getIconFileName(screener.name)}-icon.png`}
                                className="season-assessment-icon"
                                alt={screener.name}
                              />
                            </button>
                          </Col>
                        ))
                      ) : (
                        <Col xs={12}>
                          <Alert variant="info" className="text-center">
                            <FontAwesomeIcon icon={faExclamationCircle} size="3x" className="mb-3" />
                            <h4>No Screeners Available</h4>
                            <p>No screeners have been completed for this school in the {selectedYear} academic year.</p>
                          </Alert>
                        </Col>
                      )}
                    </Row>
                  </Card.Body>
                ) : (
                  <Card.Body>
                    <div className="current-selections p-3 mb-3 bg-light rounded">
                      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                        <div>
                          <h5 className="mb-1">{schoolName}</h5>
                          <div className="text-muted small">
                            <span className="me-3">Year: {selectedYear}</span>
                            <span>Screener: {screeners.find((s) => s.id === selectedScreener)?.name}</span>
                          </div>
                        </div>
                        <Button variant="secondary" size="sm" className="back-button" onClick={() => setSelectedScreener(null)}>
                          <FontAwesomeIcon icon={faArrowLeft} /> Change Screener
                        </Button>
                      </div>
                    </div>

                    <h5 className="step-indicator">Step 3: Select Classes for Export</h5>
                    <p>Select the class(es) you would like to export Aladdin Results for.</p>

                    <div className="class-selection-container">
                      <Card className="class-table-card">
                        {loading ? (
                          <div className="d-flex justify-content-center align-items-center p-5">
                            <Spinner animation="border" role="status" className="me-2" />
                            <span>Loading classes...</span>
                          </div>
                        ) : classes.length > 0 ? (
                          <>
                            <div className="table-responsive">
                              <Table bordered responsive className="mb-0">
                                <thead>
                                  <tr>
                                    <th>Class Name</th>
                                    <th width="120">Students</th>
                                    <th>
                                      Select All
                                      <Form.Check
                                        className="ms-2"
                                        type="checkbox"
                                        checked={selectAll}
                                        onChange={handleSelectAll}
                                      />
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {classes.map((cls) => (
                                    <tr
                                      key={cls.classId || cls.id}
                                      className={cls.trial_class ? "trial-class-row" : ""}
                                    >
                                      <td>
                                        <div className="trial-class-name">
                                          <span>{cls.name}</span>
                                          {cls.trial_class && (
                                            <span className="trial-badge">FAKE</span>
                                          )}
                                        </div>
                                      </td>
                                      <td className="student-count-cell">
                                        <div className="student-count-display">
                                          <FontAwesomeIcon icon={faUsers} className="text-muted" size="sm" />
                                          <span className="student-count-number">
                                            {cls.studentNumber || 0}
                                          </span>
                                        </div>
                                      </td>
                                      <td>
                                        <Form.Check
                                          type="checkbox"
                                          checked={selectedClasses.includes(cls.classId || cls.id)}
                                          onChange={() => handleClassSelect(cls.classId || cls.id)}
                                        />
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>
                            {selectedClasses.length > 0 && (
                              <div className="selection-summary p-3 bg-light">
                                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                  <p className="mb-0">
                                    Selected {selectedClasses.length} of {classes.length} classes
                                  </p>
                                  <div className="d-flex align-items-center text-primary">
                                    <FontAwesomeIcon icon={faUsers} className="me-1" />
                                    <span className="fw-bold">{getTotalSelectedStudents()} total students</span>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        ) : (
                          <Card.Body>
                            <Alert variant="info" className="text-center my-0">
                              <FontAwesomeIcon icon={faExclamationCircle} size="3x" className="mb-3" />
                              <h4>No Classes Found</h4>
                              <p>There are no classes available for {screeners.find((s) => s.id === selectedScreener)?.name} in the {selectedYear} academic year.</p>
                              <div className="mt-3">
                                <Button variant="outline-primary" className="me-2" onClick={() => setSelectedYear(null)}>
                                  Try Another Year
                                </Button>
                                <Button variant="outline-secondary" onClick={() => setSelectedScreener(null)}>
                                  Try Another Screener
                                </Button>
                              </div>
                            </Alert>
                          </Card.Body>
                        )}
                      </Card>

                      {classes.length > 0 && (
                        <div className="export-button-container mt-3">
                          <Button
                            variant="info"
                            onClick={() => setShowHelpModal(true)}
                          >
                            <FontAwesomeIcon icon={faQuestionCircle} className="me-1" />
                            How to Import Results
                          </Button>

                          <Button
                            className="email-button"
                            variant="success"
                            onClick={() => setShowModal(true)}
                            disabled={emailLoading || selectedClasses.length === 0}
                          >
                            {emailLoading ? (
                              <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                <span>Sending...</span>
                              </>
                            ) : "EMAIL"}
                          </Button>

                          <Button
                            className="export-button"
                            variant="success"
                            onClick={exportResults}
                            disabled={exportLoading || selectedClasses.length === 0}
                          >
                            {exportLoading ? (
                              <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                <span>Exporting...</span>
                              </>
                            ) : "EXPORT"}
                          </Button>
                        </div>
                      )}
                    </div>
                  </Card.Body>
                )}
              </Card>
            </div>
          </Col>
        </Row>
      </div>

      {window.innerWidth < window.innerHeight && <OrientationPrompt />}

      {/* Modal for selecting teacher to email */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Header closeButton className="bg-light">
          <Modal.Title>Select Teachers to Email</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {teachers ? (
            <div>
              <p className="text-muted mb-3">Select one or more teachers to receive the screener results</p>
              {getFilteredTeachers().length > 0 ? (
                <Form>
                  {getFilteredTeachers().map((teacher) => (
                    <div key={teacher.id} className="teacher-selection-item mb-3 p-3 border rounded">
                      <Form.Check
                        type="checkbox"
                        id={`teacher-${teacher.id}`}
                        label={
                          <div className="d-flex flex-column">
                            <span className="font-weight-bold">{teacher.name}</span>
                            <small className="text-muted">{teacher.email}</small>
                            {teacher.additionalRoles && teacher.additionalRoles.length > 0 && (
                              <div className="mt-1">
                                <small className="text-muted">Roles: </small>
                                <small>{teacher.additionalRoles.join(", ")}</small>
                              </div>
                            )}
                          </div>
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedTeachers(prev => [...prev, teacher]);
                          } else {
                            setSelectedTeachers(prev => prev.filter(t => t.id !== teacher.id));
                          }
                        }}
                      />
                    </div>
                  ))}
                </Form>
              ) : (
                <Alert variant="info" className="text-center">
                  <FontAwesomeIcon icon={faExclamationCircle} className="mb-2" size="2x" />
                  <p className="mb-0">No teachers with appropriate roles found.</p>
                  <p className="small text-muted">Only SENCO, Principal, or Secretary roles can receive these results.</p>
                </Alert>
              )}
            </div>
          ) : (
            <div className="text-center py-4">
              <Spinner animation="border" role="status" className="mb-2" />
              <p>Loading teachers...</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-between w-100 flex-wrap gap-2">
            <div>
              {selectedTeachers && selectedTeachers.length > 0 && (
                <small className="text-muted">
                  {selectedTeachers.length} teacher{selectedTeachers.length !== 1 ? 's' : ''} selected
                </small>
              )}
            </div>
            <div className="d-flex gap-2">
              <Button variant="secondary" onClick={handleCloseModal}>
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={handleSendToMultipleTeachers}
                disabled={emailLoading || !selectedTeachers || selectedTeachers.length === 0}
              >
                {emailLoading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    <span>Sending...</span>
                  </>
                ) : "Send Email"}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Help Modal */}
      <Modal
        show={showHelpModal}
        onHide={() => setShowHelpModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>How to Import ALPACA Results into Aladdin</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center mb-4">
            <div className="embed-responsive embed-responsive-16by9" style={{ maxWidth: "100%", height: "30vh" }}>
              <iframe
                className="embed-responsive-item"
                src="https://www.youtube.com/embed/K9vgbw9w6bI"
                title="ALPACA to Aladdin Import Tutorial"
                allowFullScreen
                style={{ width: "60%", height: "100%" }}
              />
            </div>
          </div>

          <div className="text-center">
            <h5 className="mb-3">Download Step-by-Step Guide</h5>
            <Button
              variant="primary"
              href={PDF_URL}
              target="_blank"
              download
            >
              <FontAwesomeIcon icon={faFilePdf} className="me-2" />
              Download PDF Guide
            </Button>
            <p className="text-muted mt-3">
              <FontAwesomeIcon icon={faInfoCircle} className="me-1" />
              The PDF guide will also be included in your exported ZIP file.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowHelpModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Screener Modal for 24/25 End of Year reminders */}
      <Modal
        show={showScreenerModal}
        onHide={handleCloseScreenerModal}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton={!submittingReminder && !reminderSubmitted}>
          <Modal.Title>
            {reminderSubmitted ? (
              <span className="text-success">
                <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                Reminder Set Successfully!
              </span>
            ) : (
              "End of Year Results"
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {reminderSubmitted ? (
            <div className="text-center py-3">
              <FontAwesomeIcon icon={faCheckCircle} className="text-success mb-3" size="3x" />
              <h5>Thank you!</h5>
              <p>We'll notify you once the End of Year results are available.</p>
            </div>
          ) : (
            <>
              <div className="mb-3">
                <FontAwesomeIcon icon={faInfoCircle} className="text-info me-2" />
                <span>End of Year results for 24/25 will be available from mid-June.</span>
              </div>

              <p>Would you like us to notify you when these results become available?</p>

              <Form>
                <Form.Group>
                  <Form.Label>Email for notification (optional)</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder={teacherEmail || "Enter email address"}
                    value={reminderEmail}
                    onChange={(e) => setReminderEmail(e.target.value)}
                    disabled={submittingReminder}
                  />
                  <Form.Text className="text-muted">
                    {teacherEmail ? `We'll use your account email (${teacherEmail}) if none provided.` : ""}
                  </Form.Text>
                </Form.Group>
              </Form>
            </>
          )}
        </Modal.Body>
        {!reminderSubmitted && (
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={handleCloseScreenerModal}
              disabled={submittingReminder}
            >
              No Thanks
            </Button>
            <Button
              variant="primary"
              onClick={handleReminderSubmit}
              disabled={submittingReminder}
            >
              {submittingReminder ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  <span>Setting Reminder...</span>
                </>
              ) : (
                "Yes, Remind Me"
              )}
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    </Container>
  );
}

export default AladdinExport;
